import React, { useState, useEffect } from 'react';
import styles from './O_Footer.module.css';
import Q_FooterLogo from '@/assets/images/Q_FooterLogo.png';
import cn from 'classnames';
import { Link } from 'react-router-dom';
import W_SelectItem from '@/components/W_Wrappers/W_SelectItem/W_SelectItem';
import A_Input from '@/components/A_Atoms/A_Input/A_Input';
import A_Button from '@/components/A_Atoms/A_Button/A_Button';
import { useLanguage } from '@/contexts/LanguageContext';
import { getTranslation } from '@/constants/translations';
import { PATHS } from '@/constants/paths';

const options = [
  'footer.interactiveMenuItems.select.wantToCollaborate',
  'footer.interactiveMenuItems.select.wantToBePartner',
  'footer.interactiveMenuItems.select.feedbackOrIdea',
  'footer.interactiveMenuItems.select.commercialProposal',
  'footer.interactiveMenuItems.select.mediaPublication',
  'footer.interactiveMenuItems.select.other',
];

export default function O_Footer() {
  const { language } = useLanguage();
  const t = (key: string) => getTranslation(language, key);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    setSelectedIndex(0);
  }, [language]);

  const getCurrentLabel = () => {
    return t(options[selectedIndex]);
  };

  const handleSelectChange = (newValue: string) => {
    const newIndex = options.findIndex(option => t(option) === newValue);
    setSelectedIndex(newIndex >= 0 ? newIndex : 0);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <footer className={styles.wrapper}>
      <div className={styles.interactive_wrapper}>
        <div className={styles.menu_wrapper}>
          <h4 className={styles.menu_title}>{t('footer.menuTitles.menu')}</h4>
          <div className={styles.menu_items_wrapper}>
            <Link to={PATHS.ABOUT} className={cn(styles.menu_item, 'text-p-9')}>
              {t('footer.menuItems.about')}
            </Link>
            <Link
              to={PATHS.CAPSULES}
              className={cn(styles.menu_item, 'text-p-9')}
            >
              {t('footer.menuItems.myCapsules')}
            </Link>
            <Link to={PATHS.FAQ} className={cn(styles.menu_item, 'text-p-9')}>
              {t('footer.menuItems.faq')}
            </Link>
            <Link
              to={PATHS.PROFILE_WITH_TAB('notifications')}
              className={cn(styles.menu_item, 'text-p-9')}
            >
              {t('footer.menuItems.notifications')}
            </Link>
            <Link to={PATHS.HOME} className={cn(styles.menu_item, 'text-p-9')}>
              {t('footer.menuItems.feed')}
            </Link>
            <Link
              to={PATHS.PROFILE}
              className={cn(styles.menu_item, 'text-p-9')}
            >
              {t('footer.menuItems.profile')}
            </Link>
          </div>
        </div>
        <div className={styles.menu_wrapper}>
          <h4 className={styles.menu_title}>
            {t('footer.menuTitles.contacts')}
          </h4>
          <div className={styles.menu_items_wrapper}>
            <span className={cn(styles.menu_item, 'text-p-9')}>
              +7 (999) 999 99-99
            </span>
            <span className={cn(styles.menu_item, 'text-p-9')}>
              hello@timecaps.com
            </span>
          </div>
        </div>
        <div className={styles.menu_wrapper}>
          <h4 className={styles.menu_title}>
            {t('footer.menuTitles.weWillContactYou')}
          </h4>
          <div className={styles.interactive_menu_wrapper}>
            <W_SelectItem
              size='wide'
              onSelect={handleSelectChange}
              defaultLabel={getCurrentLabel()}
              options={options.map(option => t(option))}
            />
            <form className={styles.input_wrapper} onSubmit={handleSubmit}>
              <A_Input
                label={t('footer.interactiveMenuItems.input.yourEmail')}
                value={inputValue}
                onChange={setInputValue}
                background='gray'
                type='email'
              />
              {/* TODO: адаптив для кнопки */}
              <A_Button
                size='small'
                variant='secondary'
                fontSize='text-p-4'
                type='submit'
                disabled={!inputValue}
              >
                {t('footer.interactiveMenuItems.button.send')}
              </A_Button>
            </form>
          </div>
        </div>
      </div>
      <div className={styles.logo_wrapper}>
        <img src={Q_FooterLogo} alt='Footer Logo' />
      </div>
      <div className={styles.info_wrapper}>
        <span className={cn(styles.info_text, 'text-p-6')}>
          2026 © Timecaps
        </span>
        <div className={styles.links_wrapper}>
          <Link to='/' className={cn(styles.link, 'text-p-9')}>
            {t('footer.links.privacyPolicy')}
          </Link>
          <Link to='/' className={cn(styles.link, 'text-p-9')}>
            {t('footer.links.termsOfUse')}
          </Link>
        </div>
      </div>
    </footer>
  );
}
